import { useUser } from '@/hooks/useUser';
import { hasOwnerPermissions } from '@/utils/permissions';
import { BaseSettingsLayout } from './BaseSettingsLayout';

export const AccountSettingsLayout = () => {
  const { data: user } = useUser();

  const isOwner = hasOwnerPermissions(user?.role);

  const sidebarNavItems = [
    {
      title: 'Profile',
      href: '/account/profile',
    },
    ...(isOwner
      ? [
          {
            title: 'Billing',
            href: '/account/billing',
          },
        ]
      : []),
  ];

  return (
    <BaseSettingsLayout
      title="Account Settings"
      sidebarNavItems={sidebarNavItems}
    />
  );
};
